module.exports = __webpack_public_path__ + "static/img/home_logo_001.56ea7d87.png";